/* ==========================================================================
   AURA STORE — WISHLIST PAGE V1
   Path: assets/aura-wishlist-page.js

   Requires:
   - assets/aura-wishlist.js
   - a section root with [data-aura-wishlist-page]
   ========================================================================== */

(function () {
  'use strict';

  var roots =
    Array.prototype.slice.call(
      document.querySelectorAll(
        '[data-aura-wishlist-page]'
      )
    );

  if (!roots.length) {
    return;
  }

  var productCache = new Map();

  function init(root) {
    if (
      root.getAttribute(
        'data-aura-wishlist-initialized'
      ) === 'true'
    ) {
      return;
    }

    root.setAttribute(
      'data-aura-wishlist-initialized',
      'true'
    );

    var configNode =
      root.querySelector(
        '[data-aura-wishlist-config]'
      );

    var grid =
      root.querySelector(
        '[data-aura-wishlist-grid]'
      );

    var filled =
      root.querySelector(
        '[data-aura-wishlist-filled]'
      );

    var empty =
      root.querySelector(
        '[data-aura-wishlist-empty]'
      );

    var countNode =
      root.querySelector(
        '[data-aura-wishlist-page-count]'
      );

    var live =
      root.querySelector(
        '[data-aura-wishlist-live]'
      );

    if (
      !configNode ||
      !grid ||
      !filled ||
      !empty
    ) {
      return;
    }

    var config = {};

    try {
      config =
        JSON.parse(
          configNode.textContent ||
          '{}'
        );
    } catch (error) {
      config = {};
    }

    var rootUrl =
      String(
        config.rootUrl ||
        (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        ) ||
        '/'
      );

    if (
      rootUrl.slice(-1) !==
      '/'
    ) {
      rootUrl += '/';
    }

    var locale =
      document.documentElement.lang ||
      'fr';

    var currency =
      (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
      ) ||
      config.currency ||
      'EUR';

    var renderToken = 0;
    var scheduled = null;

    function escapeHtml(value) {
      return String(
        value == null
          ? ''
          : value
      )
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function money(cents) {
      var numeric =
        Number(cents);

      if (!Number.isFinite(numeric)) {
        return '';
      }

      try {
        return new Intl.NumberFormat(
          locale,
          {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }
        ).format(
          numeric / 100
        );
      } catch (error) {
        return (
          (numeric / 100)
            .toFixed(2)
            .replace('.', ',') +
          ' ' +
          currency
        );
      }
    }

    function productUrl(handle, product) {
      if (
        product &&
        product.url
      ) {
        return product.url;
      }

      return (
        rootUrl +
        'products/' +
        encodeURIComponent(handle)
      );
    }

    function imageUrl(value, width) {
      if (!value) {
        return '';
      }

      try {
        var url =
          new URL(
            value,
            window.location.origin
          );

        if (width) {
          url.searchParams.set(
            'width',
            String(width)
          );
        }

        return url.toString();
      } catch (error) {
        return value;
      }
    }

    function getOptionNames(product) {
      if (
        !product ||
        !Array.isArray(product.options)
      ) {
        return [];
      }

      return product.options.map(
        function (option) {
          if (
            option &&
            typeof option === 'object'
          ) {
            return String(
              option.name ||
              option.title ||
              ''
            );
          }

          return String(
            option ||
            ''
          );
        }
      );
    }

    function normalize(value) {
      return String(
        value ||
        ''
      )
        .normalize('NFD')
        .replace(
          /[\u0300-\u036f]/g,
          ''
        )
        .toLowerCase()
        .trim();
    }

    function collectOptionValues(
      product,
      index
    ) {
      var seen = new Set();
      var values = [];

      (
        product.variants ||
        []
      ).forEach(
        function (variant) {
          var value =
            variant &&
            Array.isArray(
              variant.options
            )
              ? variant.options[index]
              : null;

          value =
            value == null
              ? ''
              : String(value);

          if (
            value &&
            !seen.has(value)
          ) {
            seen.add(value);
            values.push(value);
          }
        }
      );

      return values;
    }

    function getSizeModel(product) {
      var optionNames =
        getOptionNames(product);

      var aliases = [
        'size',
        'taille',
        'grosse',
        'größe',
        'storlek',
        'størrelse',
        'maat'
      ];

      var colorAliases = [
        'color',
        'colour',
        'couleur',
        'farbe',
        'farg',
        'färg',
        'kleur'
      ];

      var sizeIndex = -1;

      optionNames.some(
        function (name, index) {
          var normalized =
            normalize(name);

          if (
            aliases.indexOf(
              normalized
            ) !== -1
          ) {
            sizeIndex = index;
            return true;
          }

          return false;
        }
      );

      /*
        Safe fallback:
        first multi-value option that is not a colour option.
      */
      if (sizeIndex === -1) {
        optionNames.some(
          function (name, index) {
            var normalized =
              normalize(name);

            var values =
              collectOptionValues(
                product,
                index
              );

            if (
              values.length > 1 &&
              colorAliases.indexOf(
                normalized
              ) === -1
            ) {
              sizeIndex = index;
              return true;
            }

            return false;
          }
        );
      }

      if (sizeIndex === -1) {
        return null;
      }

      var hasOtherMulti =
        optionNames.some(
          function (_, index) {
            if (
              index ===
              sizeIndex
            ) {
              return false;
            }

            return (
              collectOptionValues(
                product,
                index
              ).length > 1
            );
          }
        );

      if (hasOtherMulti) {
        return null;
      }

      var values =
        collectOptionValues(
          product,
          sizeIndex
        );

      return {
        index: sizeIndex,
        name:
          optionNames[sizeIndex] ||
          config.sizeLabel ||
          'Size',
        values: values
      };
    }

    function findVariantForSize(
      product,
      sizeModel,
      sizeValue
    ) {
      return (
        product.variants ||
        []
      ).find(
        function (variant) {
          return (
            variant &&
            Array.isArray(
              variant.options
            ) &&
            String(
              variant.options[
                sizeModel.index
              ] ||
              ''
            ) ===
              String(
                sizeValue
              )
          );
        }
      ) || null;
    }

    function getProductImages(product) {
      var images = [];

      if (
        product &&
        Array.isArray(product.images)
      ) {
        images =
          product.images
            .map(function (image) {
              if (
                image &&
                typeof image === 'object'
              ) {
                return (
                  image.src ||
                  image.url ||
                  ''
                );
              }

              return String(
                image ||
                ''
              );
            })
            .filter(Boolean);
      }

      if (
        !images.length &&
        product &&
        product.featured_image
      ) {
        images.push(
          typeof product.featured_image ===
            'object'
            ? (
                product.featured_image.src ||
                product.featured_image.url ||
                ''
              )
            : product.featured_image
        );
      }

      return images
        .filter(Boolean)
        .slice(0, 4);
    }

    function snapshotCard(item) {
      var snapshot =
        item.snapshot ||
        {};

      var image =
        snapshot.image
          ? (
              '<img ' +
                'src="' +
                escapeHtml(
                  imageUrl(
                    snapshot.image,
                    720
                  )
                ) +
                '" ' +
                'alt="' +
                escapeHtml(
                  snapshot.title ||
                  ''
                ) +
                '" ' +
                'loading="lazy">'
            )
          : '';

      return (
        '<article ' +
          'class="aura-wishlist-card is-loading" ' +
          'data-aura-wishlist-card ' +
          'data-product-handle="' +
          escapeHtml(
            item.handle
          ) +
          '">' +

          '<div class="aura-wishlist-card__media">' +
            image +

            '<button ' +
              'class="aura-wishlist-card__remove" ' +
              'type="button" ' +
              'data-aura-wishlist-remove ' +
              'data-product-handle="' +
              escapeHtml(
                item.handle
              ) +
              '" ' +
              'aria-label="' +
              escapeHtml(
                config.removeLabel ||
                'Retirer de la wishlist'
              ) +
              '">' +
                '<span aria-hidden="true">♥</span>' +
            '</button>' +
          '</div>' +

          '<div class="aura-wishlist-card__body">' +
            '<span class="aura-wishlist-card__vendor">' +
              escapeHtml(
                snapshot.vendor ||
                ''
              ) +
            '</span>' +

            '<span class="aura-wishlist-card__title">' +
              escapeHtml(
                snapshot.title ||
                item.handle
              ) +
            '</span>' +

            '<span class="aura-wishlist-card__price">' +
              (
                snapshot.price != null
                  ? money(
                      snapshot.price
                    )
                  : ''
              ) +
            '</span>' +

            '<div class="aura-wishlist-card__loading-line"></div>' +
          '</div>' +
        '</article>'
      );
    }

    function cardMarkup(
      product,
      handle
    ) {
      var images =
        getProductImages(
          product
        );

      var mainImage =
        images.length
          ? imageUrl(
              images[0],
              900
            )
          : '';

      var compare =
        Number(
          product.compare_at_price_max ||
          product.compare_at_price ||
          0
        );

      var price =
        Number(
          product.price ||
          0
        );

      var hasCompare =
        compare > price;

      var media =
        mainImage
          ? (
              '<img ' +
                'src="' +
                escapeHtml(
                  mainImage
                ) +
                '" ' +
                'alt="' +
                escapeHtml(
                  product.title ||
                  ''
                ) +
                '" ' +
                'loading="lazy" ' +
                'data-aura-wishlist-card-image>'
            )
          : (
              '<span ' +
                'class="aura-wishlist-card__image-empty" ' +
                'aria-hidden="true">' +
              '</span>'
            );

      var scrub =
        images.length > 1
          ? (
              '<span ' +
                'class="aura-wishlist-card__scrub" ' +
                'data-aura-wishlist-scrub ' +
                'aria-hidden="true">' +
                  '<span>AURA</span>' +
                  '<i></i>' +
              '</span>'
            )
          : '';

      var priceMarkup =
        '<span>' +
          money(price) +
        '</span>' +
        (
          hasCompare
            ? (
                '<s>' +
                  money(compare) +
                '</s>'
              )
            : ''
        );

      var actions = '';
      var variants =
        Array.isArray(
          product.variants
        )
          ? product.variants
          : [];

      if (
        variants.length === 1
      ) {
        var variant =
          variants[0];

        if (
          variant &&
          variant.available
        ) {
          actions =
            '<button ' +
              'class="aura-wishlist-card__direct-add" ' +
              'type="button" ' +
              'data-aura-wishlist-add ' +
              'data-variant-id="' +
              escapeHtml(
                variant.id
              ) +
              '">' +
                '<span>' +
                  escapeHtml(
                    config.addLabel ||
                    'Ajouter au panier'
                  ) +
                '</span>' +
                '<span aria-hidden="true">→</span>' +
            '</button>';
        } else {
          actions =
            '<span class="aura-wishlist-card__sold-out">' +
              escapeHtml(
                config.soldOutLabel ||
                'Épuisé'
              ) +
            '</span>';
        }
      } else {
        var sizeModel =
          getSizeModel(
            product
          );

        if (sizeModel) {
          var sizeButtons =
            sizeModel.values
              .map(
                function (value) {
                  var variant =
                    findVariantForSize(
                      product,
                      sizeModel,
                      value
                    );

                  var available =
                    Boolean(
                      variant &&
                      variant.available
                    );

                  if (
                    available
                  ) {
                    return (
                      '<button ' +
                        'class="aura-wishlist-card__size" ' +
                        'type="button" ' +
                        'data-aura-wishlist-add ' +
                        'data-variant-id="' +
                        escapeHtml(
                          variant.id
                        ) +
                        '" ' +
                        'aria-label="' +
                        escapeHtml(
                          (
                            product.title ||
                            ''
                          ) +
                          ' — ' +
                          sizeModel.name +
                          ' ' +
                          value
                        ) +
                        '">' +
                          escapeHtml(
                            value
                          ) +
                      '</button>'
                    );
                  }

                  return (
                    '<button ' +
                      'class="aura-wishlist-card__size is-unavailable" ' +
                      'type="button" ' +
                      'disabled ' +
                      'aria-disabled="true">' +
                        escapeHtml(
                          value
                        ) +
                    '</button>'
                  );
                }
              )
              .join('');

          actions =
            '<div class="aura-wishlist-card__sizes">' +
              '<span class="aura-wishlist-card__size-label">' +
                escapeHtml(
                  sizeModel.name
                ) +
              '</span>' +

              '<div class="aura-wishlist-card__size-list">' +
                sizeButtons +
              '</div>' +
            '</div>';
        } else {
          actions =
            '<a ' +
              'class="aura-wishlist-card__view" ' +
              'href="' +
              escapeHtml(
                productUrl(
                  handle,
                  product
                )
              ) +
              '">' +
                '<span>' +
                  escapeHtml(
                    config.viewLabel ||
                    'Voir le produit'
                  ) +
                '</span>' +
                '<span aria-hidden="true">→</span>' +
            '</a>';
        }
      }

      var imageData =
        escapeHtml(
          JSON.stringify(
            images
          )
        );

      return (
        '<article ' +
          'class="aura-wishlist-card" ' +
          'data-aura-wishlist-card ' +
          'data-product-handle="' +
          escapeHtml(
            handle
          ) +
          '" ' +
          'data-aura-wishlist-images="' +
          imageData +
          '">' +

          '<div class="aura-wishlist-card__media">' +
            '<a ' +
              'class="aura-wishlist-card__media-link" ' +
              'href="' +
              escapeHtml(
                productUrl(
                  handle,
                  product
                )
              ) +
              '">' +
                media +
            '</a>' +

            scrub +

            '<button ' +
              'class="aura-wishlist-card__remove" ' +
              'type="button" ' +
              'data-aura-wishlist-remove ' +
              'data-product-handle="' +
              escapeHtml(
                handle
              ) +
              '" ' +
              'aria-label="' +
              escapeHtml(
                config.removeLabel ||
                'Retirer de la wishlist'
              ) +
              '">' +
                '<span aria-hidden="true">♥</span>' +
            '</button>' +
          '</div>' +

          '<div class="aura-wishlist-card__body">' +
            '<div class="aura-wishlist-card__identity">' +
              '<span class="aura-wishlist-card__vendor">' +
                escapeHtml(
                  product.vendor ||
                  ''
                ) +
              '</span>' +

              '<a ' +
                'class="aura-wishlist-card__title" ' +
                'href="' +
                escapeHtml(
                  productUrl(
                    handle,
                    product
                  )
                ) +
                '">' +
                  escapeHtml(
                    product.title ||
                    handle
                  ) +
              '</a>' +

              '<span class="aura-wishlist-card__price">' +
                priceMarkup +
              '</span>' +
            '</div>' +

            '<div class="aura-wishlist-card__actions">' +
              actions +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    function unavailableCard(
      item
    ) {
      var snapshot =
        item.snapshot ||
        {};

      return (
        '<article ' +
          'class="aura-wishlist-card is-unavailable" ' +
          'data-aura-wishlist-card ' +
          'data-product-handle="' +
          escapeHtml(
            item.handle
          ) +
          '">' +

          '<div class="aura-wishlist-card__media">' +
            (
              snapshot.image
                ? (
                    '<img ' +
                      'src="' +
                      escapeHtml(
                        imageUrl(
                          snapshot.image,
                          720
                        )
                      ) +
                      '" ' +
                      'alt="' +
                      escapeHtml(
                        snapshot.title ||
                        ''
                      ) +
                      '" ' +
                      'loading="lazy">'
                  )
                : ''
            ) +

            '<button ' +
              'class="aura-wishlist-card__remove" ' +
              'type="button" ' +
              'data-aura-wishlist-remove ' +
              'data-product-handle="' +
              escapeHtml(
                item.handle
              ) +
              '" ' +
              'aria-label="' +
              escapeHtml(
                config.removeLabel ||
                'Retirer de la wishlist'
              ) +
              '">' +
                '<span aria-hidden="true">♥</span>' +
            '</button>' +
          '</div>' +

          '<div class="aura-wishlist-card__body">' +
            '<span class="aura-wishlist-card__vendor">' +
              escapeHtml(
                snapshot.vendor ||
                ''
              ) +
            '</span>' +

            '<span class="aura-wishlist-card__title">' +
              escapeHtml(
                snapshot.title ||
                item.handle
              ) +
            '</span>' +

            '<span class="aura-wishlist-card__sold-out">' +
              escapeHtml(
                config.unavailableLabel ||
                'Produit indisponible'
              ) +
            '</span>' +
          '</div>' +
        '</article>'
      );
    }

    function updateCount(value) {
      if (!countNode) {
        return;
      }

      var count =
        Number(value) || 0;

      var label =
        count === 1
          ? (
              config.countSingular ||
              'PIÈCE MISE DE CÔTÉ'
            )
          : (
              config.countPlural ||
              'PIÈCES MISES DE CÔTÉ'
            );

      countNode.textContent =
        String(count)
          .padStart(
            2,
            '0'
          ) +
        ' ' +
        label;
    }

    function setEmptyState(isEmpty) {
      filled.hidden =
        isEmpty;

      empty.hidden =
        !isEmpty;
    }

    function fetchProduct(handle) {
      var normalized =
        String(handle || '')
          .trim();

      if (!normalized) {
        return Promise.reject(
          new Error(
            'Missing product handle'
          )
        );
      }

      if (
        productCache.has(
          normalized
        )
      ) {
        return Promise.resolve(
          productCache.get(
            normalized
          )
        );
      }

      var url =
        rootUrl +
        'products/' +
        encodeURIComponent(
          normalized
        ) +
        '.js';

      return fetch(
        url,
        {
          headers: {
            'Accept':
              'application/json'
          }
        }
      )
        .then(
          function (response) {
            if (!response.ok) {
              throw new Error(
                'Product request failed: ' +
                response.status
              );
            }

            return response.json();
          }
        )
        .then(
          function (product) {
            productCache.set(
              normalized,
              product
            );

            return product;
          }
        );
    }

    function replaceCard(
      handle,
      html
    ) {
      var existing =
        grid.querySelector(
          '[data-aura-wishlist-card]' +
          '[data-product-handle="' +
          CSS.escape(handle) +
          '"]'
        );

      if (!existing) {
        return;
      }

      var wrapper =
        document.createElement(
          'div'
        );

      wrapper.innerHTML =
        html.trim();

      var replacement =
        wrapper.firstElementChild;

      if (!replacement) {
        return;
      }

      existing.replaceWith(
        replacement
      );
    }

    function refreshSnapshotsWithProduct(
      handle,
      product
    ) {
      if (
        !window.AuraWishlist ||
        !product
      ) {
        return;
      }

      var images =
        getProductImages(
          product
        );

      window.AuraWishlist.add(
        handle,
        {
          id:
            product.id ||
            null,

          title:
            product.title ||
            '',

          vendor:
            product.vendor ||
            '',

          url:
            productUrl(
              handle,
              product
            ),

          image:
            images[0] ||
            '',

          price:
            Number(
              product.price ||
              0
            ),

          compareAtPrice:
            Number(
              product.compare_at_price_max ||
              product.compare_at_price ||
              0
            )
        },
        {
          source:
            'wishlist-page-refresh'
        }
      );
    }

    function loadFreshProducts(
      wishlistItems,
      token
    ) {
      var queue =
        wishlistItems.slice();

      var concurrency = 4;
      var workers = [];

      function worker() {
        if (
          token !==
          renderToken
        ) {
          return Promise.resolve();
        }

        var item =
          queue.shift();

        if (!item) {
          return Promise.resolve();
        }

        return fetchProduct(
          item.handle
        )
          .then(
            function (product) {
              if (
                token !==
                renderToken
              ) {
                return;
              }

              replaceCard(
                item.handle,
                cardMarkup(
                  product,
                  item.handle
                )
              );

              /*
                Refresh the saved snapshot without changing ordering.
                AuraWishlist.add() updates an existing item in-place.
              */
              refreshSnapshotsWithProduct(
                item.handle,
                product
              );
            }
          )
          .catch(
            function () {
              if (
                token !==
                renderToken
              ) {
                return;
              }

              replaceCard(
                item.handle,
                unavailableCard(
                  item
                )
              );
            }
          )
          .then(worker);
      }

      for (
        var i = 0;
        i < concurrency;
        i += 1
      ) {
        workers.push(
          worker()
        );
      }

      return Promise.all(
        workers
      );
    }

    function render() {
      if (
        !window.AuraWishlist
      ) {
        return;
      }

      renderToken +=
        1;

      var token =
        renderToken;

      var wishlistItems =
        window.AuraWishlist.getAll();

      updateCount(
        wishlistItems.length
      );

      setEmptyState(
        wishlistItems.length === 0
      );

      if (
        !wishlistItems.length
      ) {
        grid.innerHTML =
          '';

        return;
      }

      grid.innerHTML =
        wishlistItems
          .map(
            snapshotCard
          )
          .join('');

      loadFreshProducts(
        wishlistItems,
        token
      );
    }

    function scheduleRender() {
      window.clearTimeout(
        scheduled
      );

      scheduled =
        window.setTimeout(
          render,
          20
        );
    }

    function refreshCart() {
      var refreshPromise =
        Promise.resolve();

      if (
        typeof window.auraRefreshCart ===
        'function'
      ) {
        try {
          refreshPromise =
            Promise.resolve(
              window.auraRefreshCart()
            );
        } catch (error) {
          refreshPromise =
            Promise.resolve();
        }
      }

      return refreshPromise
        .then(
          function () {
            return fetch(
              rootUrl +
              'cart.js',
              {
                headers: {
                  'Accept':
                    'application/json'
                }
              }
            );
          }
        )
        .then(
          function (response) {
            if (!response.ok) {
              return null;
            }

            return response.json();
          }
        )
        .then(
          function (cart) {
            if (!cart) {
              return null;
            }

            Array.prototype.slice.call(
              document.querySelectorAll(
                '[data-cart-count]'
              )
            ).forEach(
              function (node) {
                node.textContent =
                  cart.item_count;
              }
            );

            document.dispatchEvent(
              new CustomEvent(
                'aura:cart:changed',
                {
                  detail: {
                    cart: cart,
                    source:
                      'wishlist'
                  }
                }
              )
            );

            return cart;
          }
        )
        .catch(
          function () {
            return null;
          }
        );
    }

    function openCart() {
      if (
        typeof window.openAuraCart ===
        'function'
      ) {
        window.openAuraCart();
        return;
      }

      var trigger =
        document.querySelector(
          '[data-aura-cart-open]'
        );

      if (trigger) {
        trigger.click();
        return;
      }

      document.dispatchEvent(
        new CustomEvent(
          'aura:cart:open',
          {
            detail: {
              source:
                'wishlist'
            }
          }
        )
      );
    }

    function addVariant(button) {
      var variantId =
        Number(
          button.getAttribute(
            'data-variant-id'
          )
        );

      if (
        !variantId ||
        button.disabled
      ) {
        return;
      }

      var originalHtml =
        button.innerHTML;

      button.disabled =
        true;

      button.classList.add(
        'is-loading'
      );

      if (
        button.matches(
          '.aura-wishlist-card__direct-add'
        )
      ) {
        button.innerHTML =
          '<span>' +
          escapeHtml(
            config.addingLabel ||
            'Ajout…'
          ) +
          '</span>' +
          '<span aria-hidden="true">→</span>';
      }

      fetch(
        rootUrl +
        'cart/add.js',
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify(
              {
                items: [
                  {
                    id:
                      variantId,

                    quantity:
                      1
                  }
                ]
              }
            )
        }
      )
        .then(
          function (response) {
            return response
              .json()
              .then(
                function (payload) {
                  if (!response.ok) {
                    throw new Error(
                      payload &&
                      payload.description
                        ? payload.description
                        : 'Cart add failed'
                    );
                  }

                  return payload;
                }
              );
          }
        )
        .then(
          function (payload) {
            document.dispatchEvent(
              new CustomEvent(
                'aura:cart:add',
                {
                  detail: {
                    item: payload,
                    source:
                      'wishlist'
                  }
                }
              )
            );

            if (
              button.matches(
                '.aura-wishlist-card__direct-add'
              )
            ) {
              button.innerHTML =
                '<span>' +
                escapeHtml(
                  config.addedLabel ||
                  'Ajouté'
                ) +
                '</span>' +
                '<span aria-hidden="true">✓</span>';
            } else {
              button.classList.add(
                'is-added'
              );
            }

            return refreshCart();
          }
        )
        .then(
          function () {
            openCart();

            window.setTimeout(
              function () {
                button.disabled =
                  false;

                button.classList.remove(
                  'is-loading',
                  'is-added'
                );

                button.innerHTML =
                  originalHtml;
              },
              850
            );
          }
        )
        .catch(
          function () {
            button.disabled =
              false;

            button.classList.remove(
              'is-loading',
              'is-added'
            );

            button.innerHTML =
              originalHtml;

            if (live) {
              live.textContent =
                config.errorLabel ||
                'Une erreur est survenue.';
            }
          }
        );
    }

    function scrubCard(
      card,
      event
    ) {
      if (
        !window.matchMedia(
          '(hover:hover) and (pointer:fine)'
        ).matches
      ) {
        return;
      }

      var raw =
        card.getAttribute(
          'data-aura-wishlist-images'
        );

      if (!raw) {
        return;
      }

      var images = [];

      try {
        images =
          JSON.parse(raw);
      } catch (error) {
        images = [];
      }

      if (
        images.length < 2
      ) {
        return;
      }

      var rect =
        card.getBoundingClientRect();

      var ratio =
        Math.max(
          0,
          Math.min(
            0.999,
            (
              event.clientX -
              rect.left
            ) /
            rect.width
          )
        );

      var index =
        Math.floor(
          ratio *
          images.length
        );

      var image =
        card.querySelector(
          '[data-aura-wishlist-card-image]'
        );

      if (image) {
        var next =
          imageUrl(
            images[index],
            900
          );

        if (
          image.getAttribute(
            'src'
          ) !== next
        ) {
          image.setAttribute(
            'src',
            next
          );
        }
      }

      var progress =
        card.querySelector(
          '[data-aura-wishlist-scrub] i'
        );

      if (progress) {
        progress.style.setProperty(
          '--aura-wishlist-scrub',
          (
            (
              index + 1
            ) /
            images.length
          ) *
          100 +
          '%'
        );
      }
    }

    root.addEventListener(
      'click',
      function (event) {
        var removeButton =
          event.target.closest
            ? event.target.closest(
                '[data-aura-wishlist-remove]'
              )
            : null;

        if (removeButton) {
          event.preventDefault();

          if (
            !window.AuraWishlist
          ) {
            return;
          }

          var handle =
            removeButton.getAttribute(
              'data-product-handle'
            );

          window.AuraWishlist.remove(
            handle,
            {
              source:
                'wishlist-page'
            }
          );

          return;
        }

        var addButton =
          event.target.closest
            ? event.target.closest(
                '[data-aura-wishlist-add]'
              )
            : null;

        if (addButton) {
          event.preventDefault();

          addVariant(
            addButton
          );
        }
      }
    );

    root.addEventListener(
      'pointermove',
      function (event) {
        var media =
          event.target.closest
            ? event.target.closest(
                '.aura-wishlist-card__media'
              )
            : null;

        if (!media) {
          return;
        }

        var card =
          media.closest(
            '[data-aura-wishlist-card]'
          );

        if (card) {
          scrubCard(
            card,
            event
          );
        }
      }
    );

    document.addEventListener(
      'aura:wishlist:change',
      function (event) {
        if (
          event.detail &&
          event.detail.source ===
            'wishlist-page-refresh'
        ) {
          /*
            Snapshot refresh should not recursively re-render the page.
          */
          return;
        }

        scheduleRender();
      }
    );

    function start() {
      if (
        window.AuraWishlist
      ) {
        render();
        return;
      }

      document.addEventListener(
        'aura:wishlist:ready',
        render,
        {
          once: true
        }
      );
    }

    start();
  }

  roots.forEach(init);
})();